import { atomWithStorage } from "jotai/utils";

export const userAtom = atomWithStorage("darkMode", null);
